__turbopack_context__.v({
  "logo": "Navbar-module__4IqnvW__logo",
  "navBar": "Navbar-module__4IqnvW__navBar",
});
